import { CircleDollarSign, HandCoins, ReceiptText, ShieldPlus } from 'lucide-react'
import { type ComponentProps, forwardRef } from 'react'

import { Badge } from 'slab'
import { type BalanceTransactionCategory } from 'utils/web_api.schemas'

type BadgeProps = ComponentProps<typeof Badge>

interface TransactionCategoryBadgeProps {
  category: BalanceTransactionCategory
}

interface BadgeData {
  text: string;
  type: BadgeProps['type'];
  icon: BadgeProps['leftIcon'];
}

const categoryToBadgeData = (category: BalanceTransactionCategory): BadgeData => {
  switch (category) {
    case 'employer_allowance':
      return {
        text: 'Allowance',
        type: 'success',
        icon: HandCoins
      }
    case 'insurance_premium':
      return {
        text: 'Insurance',
        type: 'info',
        icon: ShieldPlus
      }
    case 'healthcare_expense':
      return {
        text: 'Healthcare expense',
        type: 'warning',
        icon: ReceiptText
      }
    default:
      return {
        text: 'Other',
        type: 'neutral',
        icon: CircleDollarSign
      }
  }
}

export const TransactionCategoryBadge = forwardRef<HTMLSpanElement, TransactionCategoryBadgeProps>(
  ({ category }, forwardedRef) => {
    const { text, type, icon } = categoryToBadgeData(category)

    return (
      <div className='whitespace-nowrap'>
        <Badge leftIcon={icon} type={type} bordered={false} ref={forwardedRef}>
          {text}
        </Badge>
      </div>
    )
  }
)
